import React, { useState } from 'react';
import UsersList from './UsersList';
import Roomcode from './Roomcode';
import Chat from './Chat';
import ThemeButton from './ThemeButton';

interface SideBarProps { }

const SideBar: React.FC<SideBarProps> = () => {
  const [showChat, setShowChat] = useState<boolean>(false);

  return (
    <div className='flex flex-col h-full w-full overflow-x-hidden sm:h-auto sm:m-2 scrollbar-hide'>
      <div className={`text-center ${showChat ? 'hidden' : ''} sm:block`}>
        <p className='font-mono'>share roomcode:</p>
        <Roomcode />
        <UsersList />
      </div>
      <Chat shouldDisplay={showChat} />
      <button
        className='bg-black bg-opacity-30 rounded-xl mx-28 my-2 px-2 inline-block w-auto mt-auto mb-5 sm:hidden'
        onClick={() => setShowChat(!showChat)}
      >
        {showChat ? 'hide chat' : 'show chat'}
      </button>
      <ThemeButton />
    </div>
  );
}

export default SideBar;
